import { render, staticRenderFns } from "./onMltp.vue?vue&type=template&id=1c719f66&scoped=true"
import script from "./onMltp.vue?vue&type=script&lang=js"
export * from "./onMltp.vue?vue&type=script&lang=js"
import style0 from "./onMltp.vue?vue&type=style&index=0&id=1c719f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c719f66",
  null
  
)

export default component.exports